import { render } from "./ClusterUpdate.vue?vue&type=template&id=36593119&scoped=true"
import script from "./ClusterUpdate.vue?vue&type=script&lang=js"
export * from "./ClusterUpdate.vue?vue&type=script&lang=js"

import "./ClusterUpdate.vue?vue&type=style&index=0&id=36593119&scoped=true&lang=less"

import exportComponent from "/build/cloudstack-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36593119"]])

export default __exports__